export default "<button class=\"transparent-button disabled\"><fa-icon [icon]=\"faTimesCircle\"></fa-icon><ng-content></ng-content></button>\n"